import { BlogCard } from './BlogCard';

interface RelatedPost {
  slug: string;
  title: string;
  excerpt: string;
  cover_image_url: string;
  category: string;
  author_name: string;
  published_at: string;
  reading_time_minutes: number;
}

interface BlogRelatedPostsProps {
  posts: RelatedPost[];
}

export function BlogRelatedPosts({ posts }: BlogRelatedPostsProps) {
  if (posts.length === 0) return null;

  return (
    <section className="mt-16 pt-12 border-t border-border">
      <h2 className="text-2xl font-bold text-foreground mb-8">Related Articles</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {posts.map((post) => (
          <BlogCard
            key={post.slug}
            slug={post.slug}
            title={post.title}
            excerpt={post.excerpt || ''}
            coverImageUrl={post.cover_image_url || ''}
            category={post.category || ''}
            authorName={post.author_name || 'Beatview Team'}
            publishedAt={post.published_at}
            readingTime={post.reading_time_minutes || 5}
          />
        ))}
      </div>
    </section>
  );
}
